/** Laboratory requests made at visits: open until the result is recorded here. */
import { type ServiceRequest, isLabOrder, resultLabOrder } from '@assist/core';
import { useState } from 'preact/hooks';
import { app, clock } from '../controller.js';
import { eth } from '../dates.js';
import { t } from '../i18n.js';

export function LabOrdersCard({ orders }: { orders: ServiceRequest[] }) {
  const labs = orders.filter(isLabOrder).sort((a, b) => b.authoredOn.localeCompare(a.authoredOn));
  if (!labs.length) return null;
  return (
    <div class="card" data-card="labs">
      <h3>{t.labOrders}</h3>
      <ul class="plain">
        {labs.map((sr) => (
          <LabRow key={sr.id} sr={sr} />
        ))}
      </ul>
    </div>
  );
}

function LabRow({ sr }: { sr: ServiceRequest }) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const result = sr.note?.map((n) => n.text).join(' · ');
  const save = async () => {
    if (!text.trim() || !app.session) return;
    setBusy(true);
    await app.session.save(resultLabOrder(sr, text, clock.today()));
    app.saved();
    setBusy(false);
  };
  return (
    <li data-lab={sr.id}>
      <strong>{sr.code?.text}</strong> <span class="muted">{eth(sr.authoredOn)}</span>{' '}
      {sr.status === 'active' ? <span class="pill amber">{t.pending}</span> : null}
      {result ? <div class="muted">{result}</div> : null}
      {sr.status === 'active' ? (
        <div class="row">
          <input
            aria-label={`${t.labResult}: ${sr.code?.text ?? ''}`}
            placeholder={t.labResult}
            value={text}
            onInput={(e) => setText(e.currentTarget.value)}
          />
          <button
            type="button"
            class="sec small"
            disabled={busy || !text.trim()}
            onClick={() => void save()}
          >
            {t.recordResult}
          </button>
        </div>
      ) : null}
    </li>
  );
}
